import { render } from "./Loader.vue?vue&type=template&id=7330e8ac&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=7330e8ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7330e8ac"

export default script